//sp nav
$(function () {
    $('.js-header-btn').click(function () {
        $('.js-header').toggleClass('is-active');
        $('.header__bg').toggleClass('is-open');
        $('body').toggleClass('is-lock');
    });
    $('.js-kv-btn').click(function () {
        $('.js-kv-nav').toggleClass('is-active');
        $('.header__bg').toggleClass('is-open');
        $('body').toggleClass('is-lock');
    });
});
$(window).resize(function () {
    let width = $(window).width();
    if (width >= 1024) {
        $('.js-header').removeClass('is-active');
        $('.header__bg').removeClass('is-open');
        $('body').removeClass('is-lock');
    }
});

//header
if ($('#top-header').length) {
    let headerHeight = $('#top-header').outerHeight(),
        startPos = 0;

    $(window).on('load scroll', function () {
        let scrollPos = $(this).scrollTop();
        let kvHeight = $('#top-kv').outerHeight();

        if (!$('#top-header').hasClass('lock')) {

            if (scrollPos < kvHeight) {
                $('#top-header').removeClass('show');
            } else if (scrollPos > startPos && scrollPos > headerHeight) {
                $('#top-header').removeClass('show');
            } else {
                $('#top-header').addClass('show');
            }

        }
        startPos = scrollPos;
    });
} else {
    let headerHeight = $('#header').outerHeight(),
        startPos = 0;

    $(window).on('load scroll resize', function () {
        let scrollPos = $(this).scrollTop();

        if (!$('#header').hasClass('lock')) {

            if (scrollPos <= 17) {
                $('#header').removeClass('hidden');
                $('#header').removeClass('show');
                $('#header').addClass('set');
            } else if (scrollPos > startPos && scrollPos > headerHeight) {
                $('#header').addClass('hidden');
                $('#header').removeClass('show');
                $('#header').removeClass('set');
            } else {
                $('#header').removeClass('hidden');
                $('#header').addClass('show');
                $('#header').removeClass('set');
            }

        }
        startPos = scrollPos;
    });
}